import React from 'react';
import { Routes, Route } from 'react-router-dom';
// import PropTypes from 'prop-types';

import Home from 'components/Home';
import Quiz from 'components/Quiz/Quiz';
import Leaderboard from 'components/Leaderboard';
import EndingGame from 'components/EndingGame';
import Chat from 'components/Chat';

import './styles.scss';

function App() {
  return (
    <div className="App">
    <Routes>
      <Route 
        path='/'
        element={<Home />}
      />
      <Route 
        path='/quiz'
        element={
        <Quiz />}
      />
      <Route
        path='/fin'
        element={<EndingGame/>}
        />
      <Route
        path='/scores'
        element={<Leaderboard/>}
        />
      <Route
        path='/taverne'
        element={<Chat/>}
        />
    </Routes>
    </div>
  );
}

export default App;
